/**
 * Return the correct Mixpanel or Portal event name and properties for the
 * specified event.
 *
 * This is needed because in cases like the Link or Button component we
 * pass one set of tracking data to the component, which in turn must
 * provide the correct details to each telemetry service.
 *
 * NOTE: Where you are directly calling `mixpanel.track()` or
 * `posthog.capture(),` just provide the correct details there instead of using
 * this function.
 */
export function normalizeTelemetryEvent(
  name: EventData['name'],
  meta: EventData['meta']
): NormalizedTelemetryEvent {
  if (!eventsToNormalize.includes(name)) {
    return {
      mixpanel: { name, meta },
      postHog: { name, meta },
    };
  }

  const mixpanelMeta: Record<string, unknown> = {};
  for (const key in meta) {
    if (key === 'description') {
      mixpanelMeta.Description = meta[key];
      continue;
    }

    mixpanelMeta[key] = meta[key];
  }

  const postHogName = name
    .replace('Upgrade Prompt - ', 'upsell_')
    .toLowerCase();

  return {
    mixpanel: {
      name,
      meta: mixpanelMeta,
    },
    postHog: {
      name: postHogName,
      meta,
    },
  };
}

const eventsToNormalize = [
  'Upgrade Prompt - Shown',
  'Upgrade Prompt - Clicked',
];

type EventData = {
  name: string;
  meta: Record<string, unknown> | undefined;
};

type NormalizedTelemetryEvent = {
  mixpanel: EventData;
  postHog: EventData;
};
